module.exports = __webpack_public_path__ + "static/service-datavis-cf08f7afd59d60646da152816d3d4a5d.svg";